import styled from "styled-components";
import { DialogTextBox } from "../../modal-dialog/boxes/text/dialog-text.box";

export const SessionCooldownPopupTimerRemainingDefaultBox = styled(DialogTextBox)`
  font-size: 2rem;
`;
